import * as React from 'react';

import FileSpreadsheet32 from './FileSpreadsheet32';

export const fileSpreadsheet32 = () => <FileSpreadsheet32 />;

export default {
    title: 'Icon|Content|FileSpreadsheet32',
    component: FileSpreadsheet32,
    parameters: {
        notes: "`import FileSpreadsheet32 from 'box-ui-elements/es/icon/content/FileSpreadsheet32';`",
    },
};
